import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "component-title fw-bold small border-bottom pb-2 mb-3" };
const _hoisted_2 = { class: "d-none" };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = {
    key: 0,
    class: "text-center fs-5 mb-4"
};
const _hoisted_5 = {
    key: 1,
    class: "mb-5 text-center"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = { class: "mt-4" };
const _hoisted_8 = { class: "ms-2" };
const _hoisted_9 = {
    key: 2,
    class: "text-center fs-4 text-primary mb-4"
};
const _hoisted_10 = { class: "row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4 mb-4" };
const _hoisted_11 = { class: "col" };
const _hoisted_12 = { class: "form-check" };
const _hoisted_13 = ["id", "value"];
const _hoisted_14 = ["for"];
const _hoisted_15 = { class: "fw-bold text-center fs-4 text-primary mb-4" };
const _hoisted_16 = ["src", "alt"];
import { onMounted, ref, watch } from 'vue';
import PreviewContainer from '../Shared/PreviewContainer.vue';
import { useI18n } from 'vue-i18n';
import axios from 'axios';
import StandardLoadingDisplay from '@/Shared/StandardLoadingDisplay.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AiPreview',
    props: {
        configurationId: String,
        tenantId: String,
        lid: Object,
        bottle: Object
    },
    setup(__props) {
        const { t } = useI18n();
        const props = __props;
        const loading = ref(false);
        const availablePreviewOptions = ref([]);
        const previewOption = ref(null);
        const aiPreviewImageUrl = ref(null);
        onMounted(() => {
            loadPreviewOptions();
            loadPreviousAiPreview();
        });
        //watch previewOption
        watch(previewOption, (newValue) => {
            generateAiPreview();
        });
        function loadPreviewOptions() {
            axios.post(route('configurator.configurations.previewImages.loadOptions', props.configurationId))
                .then(function (response) {
                availablePreviewOptions.value = response.data.options;
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function loadPreviousAiPreview() {
            loading.value = true;
            axios.post(route('configurator.configurations.previewImages.showAiImage', props.configurationId), {
                printAreaId: props.bottle.printAreas[0].id,
            })
                .then(function (response) {
                aiPreviewImageUrl.value = response.data.imageUrl;
                loading.value = false;
            })
                .catch(function (error) {
                // console.log(error);
                loading.value = false;
            });
        }
        function generateAiPreview() {
            aiPreviewImageUrl.value = null;
            loading.value = true;
            axios.post(route('configurator.configurations.previewImages.storeAi', props.configurationId), {
                printAreaId: props.bottle.printAreas[0].id,
                environment: previewOption.value
            })
                .then(function (response) {
                aiPreviewImageUrl.value = response.data.imageUrl;
                loading.value = false;
            })
                .catch(function (error) {
                console.log(error);
                loading.value = false;
            });
        }
        function downloadPreviewImage() {
            if (aiPreviewImageUrl.value) {
                const link = document.createElement('a');
                link.href = aiPreviewImageUrl.value;
                link.download = 'ihre_vorschau.png';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("h5", _hoisted_1, _toDisplayString(_unref(t)('Ihre Vorschau')), 1),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(PreviewContainer, {
                        configurationId: __props.configurationId,
                        tenantId: __props.tenantId,
                        bottle: props.bottle,
                        previewHeight: 1500,
                        sideView: 'front'
                    }, null, 8, ["configurationId", "tenantId", "bottle"])
                ]),
                (loading.value)
                    ? (_openBlock(), _createBlock(StandardLoadingDisplay, {
                        key: 0,
                        infoText: _unref(t)('Ihre Vorschau wird generiert...'),
                        class: "my-5"
                    }, null, 8, ["infoText"]))
                    : _createCommentVNode("", true),
                (!loading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (aiPreviewImageUrl.value === null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("p", null, _toDisplayString(_unref(t)('In welcher Umgebung möchten Sie Ihr Produkt sehen?')), 1),
                                _createElementVNode("p", null, _toDisplayString(_unref(t)('Bitte wählen Sie Ihr Szenario.')), 1)
                            ]))
                            : _createCommentVNode("", true),
                        (aiPreviewImageUrl.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createElementVNode("img", {
                                    src: aiPreviewImageUrl.value,
                                    alt: "AI Generated Preview",
                                    class: "img-fluid rounded rounded-2",
                                    style: { "max-height": "550px", "max-width": "90%" }
                                }, null, 8, _hoisted_6),
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("button", {
                                        class: "btn btn-primary d-inline-flex align-items-center",
                                        onClick: downloadPreviewImage
                                    }, [
                                        _cache[1] || (_cache[1] = _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            fill: "currentColor",
                                            class: "bi bi-cloud-download",
                                            viewBox: "0 0 16 16"
                                        }, [
                                            _createElementVNode("path", { d: "M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383" }),
                                            _createElementVNode("path", { d: "M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708z" })
                                        ], -1)),
                                        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('Vorschau herunterladen')), 1)
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (aiPreviewImageUrl.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("p", null, _toDisplayString(_unref(t)('Anderes Szenario gewünscht?')), 1)
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_10, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availablePreviewOptions.value, (option) => {
                                    return (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createElementVNode("div", _hoisted_12, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input d-none",
                                                type: "radio",
                                                id: 'ai-' + option.uuid + '-context',
                                                value: option.code,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((previewOption).value = $event))
                                            }, null, 8, _hoisted_13), [
                                                [_vModelRadio, previewOption.value]
                                            ]),
                                            _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: 'ai-' + option.uuid + '-context',
                                                style: { "cursor": "pointer" }
                                            }, [
                                                _createElementVNode("div", _hoisted_15, _toDisplayString(option.name), 1),
                                                _createElementVNode("img", {
                                                    src: option.imageUrl,
                                                    alt: option.name,
                                                    class: "img-fluid rounded rounded-2"
                                                }, null, 8, _hoisted_16)
                                            ], 8, _hoisted_14)
                                        ])
                                    ]));
                                }), 256))
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
